import React, { useState } from "react";
import "../component/modalAddSupplier.css";

import { createPortal } from "react-dom";

const ModalAddSupplier = ({
  isShowModal,
  onCloseModal,
  onSubmitData,
  supplierObject,
}) => {
  const [supplierData, setSupplierData] = useState(supplierObject);

  const closeModal = () => {
    setSupplierData({
      supplier_id: "",
      supplier_name: "",
      supplier_address: "",
      supplier_city: "",
      supplier_phone_number: "",
      supplier_tax_status: "",
      supplier_transaction_type: "",
      supplier_NPWP: "",
    });
    onCloseModal();
  };

  return createPortal(
    isShowModal && (
      <div className="modal-supplier-container">
        <div className="modal-supplier-content">
          <header className="modal-supplier-header">
            <h2 className="modal-supplier-header-title">Tambah Supplier</h2>
            <button className="modal-header-close-button" onClick={closeModal}>
              &times;
            </button>
          </header>
          <main className="modal-supplier-main">
            <div className="form-group-supplier">
              <div className="input-title-label-container">
                <span className="input-title-label">Nama Supplier</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    supplierData.supplier_name ? supplierData.supplier_name : ""
                  }
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_name: e.target.value,
                    })
                  }
                  placeholder="Masukkan nama supplier"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Alamat Supplier</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    supplierData.supplier_address
                      ? supplierData.supplier_address
                      : ""
                  }
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_address: e.target.value,
                    })
                  }
                  placeholder="Masukkan alamat supplier"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Kota Supplier</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    supplierData.supplier_city ? supplierData.supplier_city : ""
                  }
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_city: e.target.value,
                    })
                  }
                  placeholder="Masukkan kota supplier"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Kontak Supplier</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    supplierData.supplier_phone_number
                      ? supplierData.supplier_phone_number
                      : ""
                  }
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_phone_number: e.target.value,
                    })
                  }
                  placeholder="Masukkan kontak supplier"
                />
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Status Pajak</span>
              </div>
              <div className="input-patient-field-container">
                <select
                  value={supplierData.supplier_tax_status}
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_tax_status: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Pilih Status Pajak
                  </option>
                  <option value="PKP">PKP</option>
                  <option value="NON PKP">NON PKP</option>
                </select>
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">Tipe Transaksi</span>
              </div>
              <div className="input-patient-field-container">
                <select
                  value={supplierData.supplier_transaction_type}
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_transaction_type: e.target.value,
                    })
                  }
                >
                  <option value="" disabled>
                    Pilih Tipe Transaksi
                  </option>
                  <option value="TEMPO">TEMPO</option>
                  <option value="COD">COD</option>
                </select>
              </div>
              <div className="input-title-label-container">
                <span className="input-title-label">NPWP Supplier</span>
              </div>
              <div className="input-patient-field-container">
                <input
                  type="text"
                  value={
                    supplierData.supplier_NPWP ? supplierData.supplier_NPWP : ""
                  }
                  onChange={(e) =>
                    setSupplierData({
                      ...supplierData,
                      supplier_NPWP: e.target.value,
                    })
                  }
                  placeholder="Masukkan nomor NPWP supplier"
                />
              </div>
            </div>
          </main>
          <footer className="modal-supplier-footer">
            <button className="modal-close-button" onClick={closeModal}>
              Batal
            </button>
            <button
              className="modal-submit-button"
              onClick={() => {
                const isEditData = supplierData.supplier_id !== "";
                onSubmitData(supplierData, isEditData);
                setSupplierData({
                  setSupplierData: "",
                  supplier_name: "",
                  supplier_address: "",
                  supplier_city: "",
                  supplier_phone_number: "",
                  supplier_tax_status: "",
                  supplier_transaction_type: "",
                  supplier_NPWP: "",
                });
              }}
            >
              Submit
            </button>
          </footer>
        </div>
      </div>
    ),
    document.getElementById("modal")
  );
};

export default ModalAddSupplier;
